import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/style.module.scss';

const HighlightedResultName = ({ highlightedName }) => {
  // We should never normally set innerHTML like this, but Algolia already does the
  // work to highlight a result with HTML for us.
  // eslint-disable-next-line react/no-danger
  return <span className={styles.name} dangerouslySetInnerHTML={{ __html: highlightedName }} />;
};

HighlightedResultName.propTypes = {
  highlightedName: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

export default HighlightedResultName;
